import { IQueryableFilter } from "../../filters/queryable.filter"

export interface IComplexDatepickerFilter {
  dtPicker?: string
  fst?: number
  fet?: number
}

export abstract class ComplexDatepickerFilter implements IComplexDatepickerFilter, IQueryableFilter {
  public dtPicker?: string
  public fst?: number
  public fet?: number

  public abstract toJson(): any;

  public getDateKeys(): { start: string, end: string } {
    return { start: 'startTime', end: 'endTime' }
  }

  public extractFromDtPicker(): any {
    if (this.dtPicker) {
      const picker = JSON.parse(this.dtPicker)
      if (picker['type'] === 'D') {
        if (picker['dates']['start']) {
          this.fst = 1
        }
        if (picker['dates']['end']) {
          this.fet = 1
        }
      } else {
        this.fst = 1
      }
    }
  }
}

export class ComplexDatePickerFilterMapModel {
  public fst: string = 'Start Time'
  public fet: string = 'End Time'
}
